<template>
    <img-comparison-slider class="image-main-bg">
        <img loading="lazy" slot="before" class="main-image" width="100%" src="/img/before.png" />
        <img loading="lazy" slot="after" class="main-image" width="100%" src="/img/after.png" />
        <img loading="lazy" id="icon-circle" slot="handle" class="custom-relative-handle" src="/img/icons/circle-arrows.svg"/>
    </img-comparison-slider>
</template>
<script>
export default {};
</script>
<style lang="scss">
img-comparison-slider {
    --divider-width: 2px;
    --divider-color: #c0c0c0;
    --handle-opacity: 0.3;
}
.image-main-bg {
    --handle-opacity:1;
    --handle-opacity-active: 1;
    --handle-size: clamp(50px, 10vw, 39px);
    .main-image {
        min-height: 600px;
        max-height: 600px;
        object-fit: cover;
        top: 0px;
    }

    .custom-relative-handle {
        width: var(--handle-size);
        height: var(--handle-size);
        position: absolute;
        top: 220px;

        @media(max-width: 1024px) {
            top: 180px;
        }
    }
}
.image-main-bg:focus{
    outline: none!important;
}
</style>
